module.exports = __webpack_public_path__ + "img/login_image.69a173d8.png";